import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../../config/api';
import { normalizeString } from '../../utils/stringUtils';

interface Department {
  id: string;
  name: string;
}

interface Office {
  id: string;
  name: string;
}

export const useDepartmentOffice = (
  isModalOpen: boolean,
  management: string,
  office: string,
  setForm?: React.Dispatch<React.SetStateAction<any>>
) => {
  const [departments, setDepartments] = useState<Department[]>([]);
  const [offices, setOffices] = useState<Office[]>([]);

  // Load departments
  useEffect(() => {
    axios
      .get(API_ENDPOINTS.departments)
      .then(res => {
        setDepartments(res.data);
      })
      .catch(error => {
        console.error('Departmanlar yüklenemedi:', error);
        setDepartments([]);
      });
  }, []);

  // Load offices when conditions are met
  useEffect(() => {
    if (departments.length > 0 && isModalOpen && management) {
      const selectedDept = departments.find(
        d => normalizeString(d.name) === normalizeString(management)
      );

      if (selectedDept) {
        axios
          .get(API_ENDPOINTS.departmentOffices(selectedDept.id))
          .then(res => {
            setOffices(res.data);

            // Kullanıcının mevcut ofis bilgisi varsa, onu kontrol et
            if (res.data.length > 0) {
              if (office) {
                // Mevcut ofis bilgisi varsa, o ofisi bul
                const currentOffice = res.data.find(
                  (o: Office) => normalizeString(o.name) === normalizeString(office)
                );

                // Eğer mevcut ofis bulunmazsa varsayılan olarak ilk ofisi seç
                if (!currentOffice && setForm) {
                  setForm((f: any) => ({ ...f, office: res.data[0].name }));
                }
                // Mevcut ofis bulunursa, değiştirme (zaten doğru değerde)
              } else {
                // Office bilgisi yoksa, ilk ofisi seç
                if (setForm) {
                  setForm((f: any) => ({ ...f, office: res.data[0].name }));
                }
              }
            }
          })
          .catch(err => {
            console.error('Ofisler yüklenemedi:', err);
            setOffices([]);
          });
      } else {
        setOffices([]);
      }
    } else {
      setOffices([]);
    }
  }, [departments, isModalOpen, management, office, setForm]);

  return {
    departments,
    offices,
  };
};
